// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__yZcjT","primary":"Button_primary__5l0vN","secondary":"Button_secondary__Tvaeo","fullWidth":"Button_fullWidth__Z_Qra","disabled":"Button_disabled__m8ayb"};